export default __webpack_public_path__ + "static/media/ic_slovakia.aa4594e8.svg";